import { Form, FormCheckbox, FormTextField, Grid, InputType, UseFormReturn, requiredRule } from '@gcl/react-core';
import * as React from 'react';
import { LabelWithMessage } from '@common/LabelWithMessage';
import usePrompt from '@common/prompt.hooks';
import { EMyGemsFormKeys, IMyGemsFormState } from './myGems.constants';
import { IMyGems } from './myGems.models';

interface IMyGemsEditForm {
  setIsFormDirty: React.Dispatch<React.SetStateAction<boolean>>;
  useFormMethods: UseFormReturn;
  myGems?: IMyGems;
}
export const MyGemsEditForm = ({ setIsFormDirty, useFormMethods, myGems }: IMyGemsEditForm) => {
  const getDefaultValues = (myGemsLocal?: IMyGems) => {
    const state: IMyGemsFormState = {
      [EMyGemsFormKeys.NAME]: myGemsLocal?.itemName ?? null,
      [EMyGemsFormKeys.SEQUENCE]: myGemsLocal?.itemSeq ?? null,
      [EMyGemsFormKeys.ACTIVE]: myGemsLocal?.itemActive ?? false,
      [EMyGemsFormKeys.IS_NEW]: myGems?.isNew ?? false,
      [EMyGemsFormKeys.URL]: myGems?.itemUrl ?? null,
    };
    return state;
  };

  return (
    <Form
      defaultValues={{
        callback: () => {
          const state = getDefaultValues(myGems);
          return state;
        },
        deps: [myGems],
      }}
      enableUnsavedChangesPrompt
      unsavedChangesPromptProps={{
        usePrompt,
      }}
      useFormMethods={useFormMethods}
      render={(formFieldMethods) => {
        return (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <LabelWithMessage labelFor={EMyGemsFormKeys.NAME} text="Name" required />
              <FormTextField id={EMyGemsFormKeys.NAME} formFieldMethods={formFieldMethods} rules={requiredRule} />
            </Grid>

            <Grid item xs={12}>
              <LabelWithMessage labelFor={EMyGemsFormKeys.URL} text="Url" />
              <FormTextField id={EMyGemsFormKeys.URL} formFieldMethods={formFieldMethods} />
            </Grid>
            <Grid item xs={12}>
              <LabelWithMessage labelFor={EMyGemsFormKeys.SEQUENCE} text="Sequence" />
              <FormTextField
                id={EMyGemsFormKeys.SEQUENCE}
                formFieldMethods={formFieldMethods}
                type={InputType.Number}
              />
            </Grid>
            <Grid item xs={12}>
              <LabelWithMessage labelFor={EMyGemsFormKeys.IS_NEW} text="Is New?" />
              <FormCheckbox formFieldMethods={formFieldMethods} id={EMyGemsFormKeys.IS_NEW} />
            </Grid>
            <Grid item xs={12}>
              <LabelWithMessage labelFor={EMyGemsFormKeys.ACTIVE} text="Is Active?" />
              <FormCheckbox formFieldMethods={formFieldMethods} id={EMyGemsFormKeys.ACTIVE} />
            </Grid>
          </Grid>
        );
      }}
    />
  );
};
